import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './admin-dashboard.scss';
import { DashboardHeader } from '../../../atoms';
import { ManageBusinessAccounts } from '../../molecules';
import { DashContentFooter } from '../../../molecules';
import { DashboardContext } from '../../../../context';

function AdminDashboard() {
  const history = useHistory();
  const [dashData, setDashData] = useState({});

  useEffect(() => {}, []);

  const handleBackClick = () => {
    history.push('/manage-accounts');
  };

  return (
    <DashboardContext.Provider value={{ dashData, setDashData }}>
      <div className="row no-gutters">
        <div className="no-gutters dash-left-wrapper">
          <DashboardHeader />
          <ManageBusinessAccounts handleBackClick={() => handleBackClick()}/>
          <DashContentFooter />
        </div>
      </div>
    </DashboardContext.Provider>
  );
}

export default AdminDashboard;
